import { nullishToOptional } from "../../../helpers";
import { DocumentationItemConfigurationV1 } from "./documentation-v1";
import { DocumentationItemConfigurationV2 } from "./documentation-v2";
import { z } from "zod";
export const DocumentationGroupBehavior = z.enum(["Group", "Tabs"]);
export const ElementGroupDataV1 = z.object({
    behavior: nullishToOptional(DocumentationGroupBehavior.optional()),
    configuration: nullishToOptional(DocumentationItemConfigurationV1),
});
export const ElementGroupDataV2 = z.object({
    behavior: nullishToOptional(DocumentationGroupBehavior.optional()),
    configuration: nullishToOptional(DocumentationItemConfigurationV2),
});
